import type { Size } from './markupGeometry.ts';
import type { MarkupShape } from './markupShapes.ts';
import { MARKUP_SIZES, fontSizeFor, strokeWidthFor, type MarkupSize } from './markupStyle.ts';

export interface StyleChange {
    color?: string;
    size?: MarkupSize;
}

function sizeValue(shape: MarkupShape): number {
    return shape.kind === 'text' ? shape.fontSize : shape.width;
}

function sizeValueFor(shape: MarkupShape, size: MarkupSize, image: Size): number {
    return shape.kind === 'text' ? fontSizeFor(size, image) : strokeWidthFor(size, image);
}

// Same object back when nothing changes, so the history records no empty step.
export function restyleShape(shape: MarkupShape, change: StyleChange, image: Size): MarkupShape {
    const color = change.color ?? shape.color;
    const value = change.size ? sizeValueFor(shape, change.size, image) : sizeValue(shape);
    if (color === shape.color && value === sizeValue(shape)) return shape;
    if (shape.kind === 'text') return { ...shape, color, fontSize: value };
    return { ...shape, color, width: value };
}

export function sizeOfShape(shape: MarkupShape, image: Size): MarkupSize | null {
    return (
        MARKUP_SIZES.find((size) => sizeValueFor(shape, size, image) === sizeValue(shape)) ?? null
    );
}
